<script lang="ts">
    import { Icon, InputGroupText } from "sveltestrap";
    import type { Question } from "../../Model/Question";
    import { getContext } from "svelte";
    import type { GetAnswerFn, SaveAnswerFn } from "../../global";
    import type { Answer } from "../../Model/Answer";
    import { debounce } from "../../Services";
    import type { Readable } from "svelte/store";
    import QuestionBox from "./QuestionBox.svelte";
    import AlertSaveError from "../AlertSaveError.svelte";

    export let question: Question;

    const saveDebounce = debounce(500);
    const getAnswer: GetAnswerFn = getContext('getAnswer');
    const readonlyForm: Readable<boolean> = getContext('readonlyForm');
    const saveAnswer: SaveAnswerFn = getContext('saveAnswer');

    let input: HTMLInputElement;
    let isSaving = false;
    let saveError = false;
    let answer: Answer;
    let value: Readable<string>;
    
    $: setupQuestion(question);

    function setupQuestion(question: Question): void {
        answer = getAnswer(question.id);
        value = answer.valueReadable;
    }

    function onInput(): void {
        if (!answer || $readonlyForm) {
            return;
        }
        answer.value = input.value;
        saveDebounce(realSaveAnswer);
    }

    async function realSaveAnswer() {
        if (!answer) {
            return;
        }
        try {
            isSaving = true;
            await saveAnswer(answer);
            saveError = false;
        } catch (error) {
            saveError = true;
        } finally {
            isSaving = false;
        }
    }

</script>

<QuestionBox {question} {isSaving}>
    <input
        bind:this={input}
        class="form-control"
        type="text"
        readonly={$readonlyForm}
        value={$value}
        on:input={onInput} />
    {#if saveError}
        <AlertSaveError />
    {/if}
</QuestionBox>
